/**
 * @file For adding toasts
 *
 *
 * @author Torbjørn Høvde
 * @version 1.1
 *
 * @example
 *
 *
 */

export default {

  methods: {
    $_toast_add (title, text, type, lifeTime = 0) {
      this.$store.dispatch('toaster/addToast', {
        title,
        text,
        type,
        lifeTime
      });
    },
    $_toast_removeAll () {
      this.$store.dispatch('toaster/removeAllToasts');
    }
  }
};
